"use client";

import { useCountUp } from "@/app/hooks/useCountUp";

type Props = {
  value: number;
};

export default function DashboardCountUp(props: Props) {
  const { value } = props;
  const displayed = useCountUp(value);

  return <>{displayed}</>;
}
